import PropTypes from 'prop-types';
import queryString from 'query-string';
import React from 'react';
import { connect } from 'react-redux';

import { ajaxErrorHandler, defaultSuccess } from '../../libs/utils';
import { USER_ACTIONS } from '../../redux/auth/actions';
import { isLoggingIn, selectLoginError } from '../../redux/auth/selectors';
import { requestPasswordResetMail } from '../../services/api/users';
import ForgotPassword from '../forms/ForgotPasswordForm';
import LoginForm from '../forms/LoginForm';
import LoginLayout from './LoginLayout';

class _Login extends React.Component {
  constructor(props) {
    super(props);
    this._handleLogin = this._handleLogin.bind(this);
    this._handleForgotPassword = this._handleForgotPassword.bind(this);
    this._toggleForm = this._toggleForm.bind(this);
    this.state = {
      showForgotPass: false,
    };
  }

  static propTypes = {
    loginRequest: PropTypes.func,
    loginError: PropTypes.string,
    isLoggingIn: PropTypes.bool,
  };

  UNSAFE_componentWillMount() {
    if (queryString.parse(window.location.search).forgotpass) {
      this.setState({
        showForgotPass: true,
      });
    }
  }

  _toggleForm(e) {
    e.preventDefault();
    this.setState({ showForgotPass: !this.state.showForgotPass });
  }

  _handleLogin(data) {
    this.props.loginRequest(data.email, data.password, data.remember);
  }

  _handleForgotPassword(data) {
    return new Promise((resolve, reject) => {
      requestPasswordResetMail({
        email: data.forgot_email,
      })
        .then((response) => {
          defaultSuccess('Reset Password Mail Sent');
        })
        .catch(ajaxErrorHandler)
        .then(() => resolve('succes'));
    });
  }

  render() {
    const formClass = !this.state.showForgotPass ? 'm-login--signin' : 'm-login--forget-password';

    return (
      <LoginLayout
        className={
          'm-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-grid--tablet-and-mobile m-grid--hor-tablet-and-mobile m-login m-login--1 ' +
          formClass
        }
      >
        <div className="m-login__wrapper">
          <div className="m-login__logo">
            <a href="/">
              <img src="assets/app/media/img/logos/logo.svg" alt="We Are One World - Crew System" />
            </a>
          </div>

          {!this.state.showForgotPass && this.props.loginError && (
            <div className="alert alert-danger">{this.props.loginError}</div>
          )}
          <div className="m-login__signin">
            <LoginForm
              onSubmit={this._handleLogin}
              forgotPassword={this._toggleForm}
              isLoggingIn={this.props.isLoggingIn}
            />
          </div>
          <div className="m-login__forget-password">
            <div className="m-login__head">
              <h3 className="m-login__title">Forgotten Password ?</h3>
              <div className="m-login__desc">Enter your email to reset your password:</div>
            </div>
            <ForgotPassword onSubmit={this._handleForgotPassword} cancel={this._toggleForm} />
          </div>
        </div>
      </LoginLayout>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    loginError: selectLoginError(state),
    isLoggingIn: isLoggingIn(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  loginRequest: (username, password, remember) => dispatch(USER_ACTIONS.loginRequest(username, password, remember)),
});

export default connect(mapStateToProps, mapDispatchToProps)(_Login);
